// THIRD-PARTY
import { combineReducers } from "redux";

// REDUCERS
// import addToCartModal     from './reducers/add-to-cart-modal';
import application from "./reducers/application";
import cart from "./reducers/cart";
import footer from "./reducers/footer";
import modal from "./reducers/modal";
import pages from "./reducers/pages";
import pdpContentful from "./reducers/pdp-contentful";
import pdpHooksCache from "./reducers/pdp-hooks-cache";
import geolocation from "./reducers/geolocation";
import productDetailPage from "@lululemon/ecom-pdp/src/store/reducers/product-detail-page";
import pdp from "@lululemon/ecom-pdp/src/store/reducers";
import searchResults from "./reducers/search-results";
import translations from "./reducers/translations";
import storeLocations from "./reducers/store-locations";
import headerBanner from "./reducers/mega-nav";
import selectStore from "./reducers/select-store";
import ld from "./reducers/ld";
import bopisReducer from "./reducers/bopis-reducer";
import giftCard from "./reducers/gift-card";
import reviews from "./reducers/reviews-reducer";
import truefit from "./reducers/truefit";

import abFlags from "./reducers/ab-flags";
import wishlists from "./reducers/wishlists";
import skus from "./reducers/skus";
import sizeGuides from "./reducers/size-guides";
import outfittingMab from "./reducers/outfitting-mab";

const rootReducer = combineReducers({
  abFlags,
  application,
  cart,
  footer,
  modal,
  pages,
  pdpContentful,
  pdpHooksCache,
  geolocation,
  pdp,
  productDetailPage,
  searchResults,
  selectStore,
  translations,
  ld,
  storeLocations,
  headerBanner,
  bopisReducer,
  reviews,
  truefit,
  giftCard,
  wishlists,
  skus,
  sizeGuides,
  outfittingMab,
});

export default rootReducer;
